import React from "react";
import Link from "next/link";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/sharp-light-svg-icons";

interface MenuItemProps {
  href: string;
  onClick: () => void;
  children: React.ReactNode;
}

const MenuItem: React.FC<MenuItemProps> = ({ href, onClick, children }) => {
  return (
    <Link aria-label="Menu" href={href} onClick={onClick} prefetch={true} className="data-gtm-menu-item">
      <div className="flex items-center gap-0.3 group">
        <FontAwesomeIcon
          className="size-5 opacity-0 text-[var(--menu-text-color)] group-hover:opacity-100 transition-opacity duration-300"
          icon={faChevronRight}
        />
        <span className="group-hover:translate-x-2 transition-transform duration-300">
          {children}
        </span>
      </div>
    </Link>
  );
};

export default MenuItem;
